import { addDays } from "date-fns";
import dayjs from "dayjs";
import localizedFormat from "dayjs/plugin/localizedFormat";
import timezone from "dayjs/plugin/timezone";
import React from "react";
import { CommandListDelivery, CommandProjectInfo } from "../CommandTypes";
import CommandListViewDateSection from "./CommandListViewDateSection";
interface CommandListViewProps {
    project: CommandProjectInfo;
    data: CommandListDelivery[];
}

dayjs.extend(localizedFormat);
dayjs.extend(timezone);

const CommandListView: React.FC<CommandListViewProps> = ({ project, data }) => {
    const [now, _] = React.useState(() => new Date());

    const deliveriesFuture = data.filter((d) =>
        dayjs(d.start_at).tz(project.timezone).startOf("day").isAfter(dayjs().tz(project.timezone).add(1, "day"), "day")
    );

    const deliveriesFutureGroupedByDate: Record<string, CommandListDelivery[]> = deliveriesFuture.reduce(
        (acc, delivery) => {
            if (!delivery.start_at) {
                return acc;
            }

            const date = dayjs(delivery.start_at).tz(project.timezone).startOf("day").toString();
            if (!acc[date]) {
                acc[date] = [];
            }

            acc[date].push(delivery);

            return acc;
        },
        {} as Record<string, CommandListDelivery[]>
    );

    const convertKeyToDate = (key: string): dayjs.Dayjs => {
        const date = new Date(key);
        if (dayjs(date).tz(project.timezone).isValid()) {
            return dayjs(date);
        } else {
            return dayjs();
        }
    };

    return (
        <div className="flex flex-col w-full gap-2">
            <CommandListViewDateSection
                label="Today"
                date={now}
                deliveries={data.filter((d) =>
                    dayjs(d.start_at).tz(project.timezone).isSame(dayjs().tz(project.timezone), "day")
                )}
                project={project}
            />
            <CommandListViewDateSection
                label="Tomorrow"
                date={addDays(now, 1)}
                deliveries={data.filter((d) =>
                    dayjs(d.start_at).tz(project.timezone).isSame(dayjs().tz(project.timezone).add(1, "day"), "day")
                )}
                project={project}
            />

            <div className="flex flex-col gap-2">
                {deliveriesFuture.length > 0 ? (
                    Object.entries(deliveriesFutureGroupedByDate).map(([key, value]) => (
                        <CommandListViewDateSection
                            key={key}
                            label={convertKeyToDate(key).tz(project.timezone).format("dddd")}
                            date={convertKeyToDate(key).tz(project.timezone).toDate()}
                            deliveries={value}
                            project={project}
                        />
                    ))
                ) : (
                    <div className="w-full text-center text-lg italic text-plot-light-grey ">
                        No Deliveries After Tomorrow
                    </div>
                )}
            </div>
        </div>
    );
};

export default CommandListView;
